let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eQZk8")).then(() => parcelRequire('8akbo'));